export const MIME_TYPE_PROBLEM_JSON = 'application/problem+json';
